/*  react-table  */
import { CellContext } from '@tanstack/react-table';

/*  Shared  */
import { Sources } from 'application/Shared/Components/Avatars';
import { Helpers } from 'application/Shared/Helpers';
import { UserApp } from 'application/Shared/types/userApp';

/*  React  */
import React from 'react';

export const UserAppSourcesCell = (props: CellContext<UserApp, unknown>) => {
    const { row, ...rest } = props;
    const sources = Helpers.getSourcesWithActivity(row.original);
    return <Sources noBadge sources={sources} max={3} {...rest} />;
};
